import { actions as dataFetchActions } from '@bufferapp/async-data-fetch';
import { actionTypes } from './reducer';

export default ({ dispatch }) =>
  (next) =>
  (action) => {
    // eslint-disable-line no-unused-vars
    next(action);
    switch (action.type) {
      case actionTypes.FETCH_PENDING_TIKTOK_POSTS:
        dispatch(
          dataFetchActions.fetch({
            name: 'pendingTiktok',
            args: {
              profileId: action.profileId,
              isFetchingMore: false,
            },
          })
        );
        break;
      default:
        break;
    }
  };
